<template>
  <div>
    <div>
      <input
        type="text"
        v-model="data.label"
        :placeholder="$t('form.terms.name')"
      />
    </div>
    <div>
      <input type="text" v-model="data.value" placeholder="https://..." />
      <span class="warning" v-if="error">
        <icon id="triangle-empty-alert" /> {{ $t("form.terms.warning") }}
      </span>
    </div>
    <required />
    <columnWidth />
  </div>
</template>
<script>
export default {
  components: {
    columnWidth() {
      return import("./width.vue");
    },
    required() {
      return import("./required.vue");
    }
  },
  props: {
    data: Object
  },
  data() {
    return {
      error: false
    };
  },
  watch: {
    "data.description"() {
      this.setSave();
    },
    "data.value"() {
      this.setSave();
    },
    "data.label"() {
      this.setSave();
    }
  },
  computed: {},
  mounted() {
    this.error = !this.validURL(this.data.value);
  },
  methods: {
    setSave() {
      var data = JSON.parse(JSON.stringify(this.$store.state.business.unsaved));
      this.data.description =
        '<a href="' + this.data.value + '" target="_blank">AGBS ansehen</a>';

      if (!this.data.value) {
        this.data.description = "";
      }

      data.form[this.$store.state.form.edit] = this.data;
      this.$store.commit("business/prefetch", data);
      this.error = !this.validURL(this.data.value);
    },
    validURL(str) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      return !!pattern.test(str);
    }
  }
};
</script>
<style lang="sass" scoped>
@import '@/assets/sass/variables.sass'
div
  margin-bottom: 10px
.warning
  font-size: 10pt
  color: $danger
input, textarea
  width: 100%
  padding: 10px
  box-sizing: border-box
  border: 1px solid $success
  &:focus
    outline: none
textarea
  margin-top: 10px
  height: 200px
</style>
